import React, { Fragment } from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Form,
  Row,
  Col,
  Button,
  Table,
  Tabs,
  message,
  Switch,
  Divider,
  Select,
} from "antd";
import AddNewVersion from "../components/addNewVersion";
import {
  fetchVersionList,
  fetchIsOpen,
  fetchHardwareVersionList,
  fetchHardwarePosition,
  fetchHardwareIsOpen,
} from "../../../api/version";
import NProgress from "nprogress";
const { TabPane } = Tabs;
const { Option } = Select;
const BreadCrumbData = [
  { path: "/page/versionmanagemnet/versionmanagemnet", name: "版本管理" },
];
const { Column } = Table;
class VersionManagement extends React.Component {
  state = {
    visible: false,
    listQuery: { pageNum: 1, pageSize: 10 },
    total: 0,
    list: [],
    hardwareListQuery: {
      pageNum: 1,
      pageSize: 10,
      position: "",
    },
    hardwareTotal: 0,
    hardwareList: [],
    type: "",
    hardwarePositionList: [],
  };
  switchChange = (record) => {
    fetchIsOpen({
      versionId: record.versionId,
      activation: !record.activation,
    }).then((res) => {
      if (res.success) {
        message.success("操作成功");
        this.getVersionList();
      }
    });
  };
  hardwareSwitchChange = (record) => {
    fetchHardwareIsOpen({
      hardwareVersionId: record.hardwareVersionId,
      activation: !record.activation,
    }).then((res) => {
      if (res.success) {
        message.success("操作成功");
        this.getHardwareVersionList();
      }
    });
  };
  handleCancel = () => {
    this.setState({
      visible: false,
    });
  };
  async componentDidMount() {
    NProgress.start();
    await this.getVersionList();
    this.getHardwarePositionList();
    NProgress.done();
  }
  //获取硬件位置列表
  getHardwarePositionList = () => {
    fetchHardwarePosition().then((res) => {
      this.setState({
        hardwarePositionList: res.data,
      });
    });
  };
  //获取硬件版本列表
  getHardwareVersionList = () => {
    fetchHardwareVersionList(this.state.hardwareListQuery).then((res) => {
      this.setState({
        hardwareList: res.data.list,
        hardwareTotal: res.data.total,
      });
    });
  };
  getVersionList = () => {
    fetchVersionList(this.state.listQuery).then((res) => {
      this.setState({
        list: res.data.list,
        total: res.data.total,
      });
    });
  };
  tabsChange = (e) => {
    if (e == 1) {
      this.getVersionList();
    } else if (e == 2) {
      this.getHardwareVersionList();
    }
  };
  selectChange = (e) => {
    this.setState({
      hardwareListQuery: { ...this.state.hardwareListQuery, position: e },
    });
  };

  hardwareSearch = () => {
    this.setState(
      {
        hardwareListQuery: { ...this.state.hardwareListQuery, pageNum: 1 },
      },
      () => this.getHardwareVersionList()
    );
  };
  renderPositionOptions = () => {
    return this.state.hardwarePositionList.map((item) => (
      <Option key={item.position} value={item.position}>
        {item.name}
      </Option>
    ));
  };
  renderType = (value) => {
    switch (value) {
      case "EV200":
        return "EV200";
        break;
      case "X5":
        return "X5";
        break;
      default:
        break;
    }
  };
  render() {
    const {
      list,
      listQuery,
      total,
      visible,
      hardwareList,
      hardwareListQuery,
      hardwareTotal,
      type,
    } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <Tabs
          style={{ padding: "0 20px" }}
          defaultActiveKey="1"
          onChange={this.tabsChange}
        >
          <TabPane tab="软件版本" key="1">
            <div style={{ margin: 0 }} className="searchTitle">
              <Row>
                <Col align="right">
                  <Button
                    type="primary"
                    onClick={() =>
                      this.setState({ visible: true, type: "software" })
                    }
                  >
                    上传版本
                  </Button>
                </Col>
              </Row>
              <div className="lineBetween"></div>
              <Table
                rowKey="versionId"
                dataSource={list}
                pagination={{
                  showTotal: () => `共${total}条`,
                  total: total,
                  pageSize: listQuery.pageSize,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  pageSizeOptions: ["10", "20", "30", "40", "100"],
                  onChange: (page, pageSize) => {
                    this.setState(
                      {
                        listQuery: {
                          ...listQuery,
                          pageNum: page,
                        },
                      },
                      () => this.getVersionList()
                    );
                  },
                  onShowSizeChange: (current, pageSize) => {
                    this.setState(
                      {
                        listQuery: {
                          ...listQuery,
                          pageSize,
                          pageNum: 1,
                        },
                      },
                      () => this.getVersionList()
                    );
                  },
                }}
              >
                <Column
                  title="上传时间"
                  dataIndex="uploadTime"
                  key="uploadTime"
                />
                <Column
                  title="设备类型"
                  dataIndex="type"
                  key="type"
                  render={this.renderType}
                />
                <Column
                  title="安装包"
                  dataIndex="key"
                  key="key"
                  render={(text) => (
                    <div style={{ wordWrap: "break-word", maxWidth: 200 }}>
                      {text}
                    </div>
                  )}
                />
                <Column title="版本号" dataIndex="versionNo" key="versionNo" />
                <Column
                  width="25%"
                  title="更新内容"
                  dataIndex="describe"
                  key="describe"
                  render={(text) => (
                    <div style={{ wordBreak: "break-all" }}>{text}</div>
                  )}
                />
                <Column
                  title="操作人"
                  dataIndex="employeesName"
                  key="employeesName"
                />
                <Column
                  width="15%"
                  title="操作"
                  render={(record) => (
                    <React.Fragment>
                      {record.activation ? (
                        <a
                          onClick={() => this.switchChange(record)}
                          style={{ color: "#FCA100" }}
                        >
                          关闭
                        </a>
                      ) : (
                        <a onClick={() => this.switchChange(record)}>启用</a>
                      )}
                      <Divider type="vertical"></Divider>{" "}
                      <a
                        onClick={() =>
                          (window.location.href = record.downLoadPath)
                        }
                      >
                        下载
                      </a>
                    </React.Fragment>
                  )}
                />
              </Table>
            </div>
          </TabPane>
          <TabPane tab="硬件版本" key="2">
            <div style={{ margin: 0 }} className="searchTitle">
              <Row>
                <Col span={20}>
                  <Select
                    style={{ width: 150, marginRight: 10 }}
                    onChange={this.selectChange}
                    placeholder="更新位置"
                    allowClear
                  >
                    {this.renderPositionOptions()}
                  </Select>
                  <Button type="primary" onClick={this.hardwareSearch}>
                    搜索
                  </Button>
                </Col>
                <Col span={4} align="right">
                  <Button
                    type="primary"
                    onClick={() =>
                      this.setState({ visible: true, type: "hardware" })
                    }
                  >
                    上传版本
                  </Button>
                </Col>
              </Row>
              <div className="lineBetween"></div>
              <Table
                rowKey="hardwareVersionId"
                dataSource={hardwareList}
                pagination={false}
                pagination={{
                  showTotal: () => `共${hardwareTotal}条`,
                  total: hardwareTotal,
                  pageSize: hardwareListQuery.pageSize,
                  showSizeChanger: true,
                  showQuickJumper: true,
                  pageSizeOptions: ["10", "20", "30", "40", "100"],
                  onChange: (page, pageSize) => {
                    this.setState(
                      {
                        hardwareListQuery: {
                          ...hardwareListQuery,
                          pageNum: page,
                        },
                      },
                      () => this.getHardwareVersionList()
                    );
                  },
                  onShowSizeChange: (current, pageSize) => {
                    this.setState(
                      {
                        hardwareListQuery: {
                          ...hardwareListQuery,
                          pageSize,
                          pageNum: 1,
                        },
                      },
                      () => this.getHardwareVersionList()
                    );
                  },
                }}
              >
                <Column title="上传时间" dataIndex="time" key="time" />
                <Column
                  title="设备类型"
                  dataIndex="type"
                  key="type"
                  render={this.renderType}
                />
                <Column
                  title="更新位置"
                  dataIndex="positionName"
                  key="positionName"
                />
                <Column
                  title="版本号"
                  dataIndex="versionName"
                  key="versionName"
                />
                <Column
                  width="40%"
                  title="更新内容"
                  dataIndex="describe"
                  key="describe"
                  render={(text) => (
                    <div style={{ wordBreak: "break-all" }}>{text}</div>
                  )}
                />
                <Column
                  title="操作人"
                  dataIndex="employeesName"
                  key="employeesName"
                />
                <Column
                  title="操作"
                  render={(record) => (
                    <React.Fragment>
                      {record.activation ? (
                        <a
                          onClick={() => this.hardwareSwitchChange(record)}
                          style={{ color: "#FCA100" }}
                        >
                          关闭
                        </a>
                      ) : (
                        <a onClick={() => this.hardwareSwitchChange(record)}>
                          启用
                        </a>
                      )}
                      <Divider type="vertical"></Divider>{" "}
                      <a
                        onClick={() =>
                          (window.location.href =
                            "https://qiniu-retail.ieou.com/" + record.key)
                        }
                      >
                        下载
                      </a>
                    </React.Fragment>
                  )}
                />
              </Table>
            </div>
          </TabPane>
        </Tabs>

        <AddNewVersion
          visible={visible}
          handleCancel={this.handleCancel}
          getVersionList={this.getVersionList}
          type={type}
          renderPositionOptions={this.renderPositionOptions}
          getHardwareVersionList={this.getHardwareVersionList}
        ></AddNewVersion>
      </div>
    );
  }
}
export default VersionManagement;
